
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Schlafmangel kann auf Dauer krank machen. `}<M mdxType="M">{`Wer allerdings wochentags zu wenig schläft, kann das Defizit am Wochenende ausgleichen`}</M>{` – ohne dass die Gesundheit leidet, berichtet ein internationales Team von Schlafforschern im «Journal of Sleep Research». «Wenn man am Wochenende nachschläft, muss man nicht jeden Tag auf die gesunden 7 bis 7,5 Stunden kommen, was auch oft für Arbeitnehmer unrealistisch ist in den heutigen Zeiten», bestätigt der Leiter des Schlafmedizinischen Zentrums an der Berliner Charité, Ingo Fietze. `}<br /><br /><M mdxType="M">{`Aber: Man kann nie allen Schlaf nachholen.`}</M>{` Schläft man unter der Woche ganze zehn Stunden zu wenig, so kann man am Wochenende nicht zehn Stunden länger schlafen. Man könne ja auch nicht die Völlerei einer Woche mit einem Diättag am Wochenende ausgleichen, schreibt der Psychologe Albrecht Vorster in seinem Buch «Warum wir schlafen». Die Sache hat auch noch einen weiteren Haken: Wer am Wochenende lange schläft, bringt seine innere Uhr durcheinander, da er zu anderen Zeiten Licht ausgesetzt ist, als er sich das gewohnt ist. Die Folge kann ein Mini-Jetlag am Montag sein.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;